export default {
      id: "ic_rank_tribun-usage",
      viewBox: "0 0 14 14",
      url: "/" + "images/icons.3.109.2.svg#ic_rank_tribun-usage",
      toString: function () {
        return this.url;
      }
    }